import React, { useState } from "react";
import { motion } from "framer-motion";
import DashboardDomainExternal from "./DashboardDomainExternal";
import DashboardContactExternal from "./DashboardContactExternal";

export default function Dashboard() {
    const [tab, setTab] = useState("domain");

    return (
        <div className="min-h-screen bg-gray-100 px-3 sm:px-4 md:px-6 py-6">
            <div className="w-full max-w-full mx-auto">
                {/* Header */}
                <div className="mb-5 sm:mb-7">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900  text-center">
                        Dashboard
                    </h1>
                    <div className="mt-3 h-px w-full bg-slate-200" />
                </div>

                {/* Notice */}
                <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
                    <div className="px-5 py-5 sm:px-6 sm:py-6">
                        <div className="flex items-start gap-4">
                            <div className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-slate-900 text-white">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-4a1 1 0 00-1 1v3a1 1 0 001 1h1a1 1 0 100-2v-2a1 1 0 00-1-1h-1zm0 8a1 1 0 100-2 1 1 0 000 2z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </div>

                            <div className="min-w-0">
                                <h2 className="text-lg sm:text-xl font-bold text-slate-900">
                                    Notice
                                </h2>
                                <p className="mt-2 text-sm sm:text-base leading-relaxed text-slate-700">
                                    You will receive the result files from{" "}
                                    <a
                                        href="mailto:charlie@ciilock.com"
                                        className="font-semibold text-slate-900 underline decoration-slate-300 underline-offset-4 hover:decoration-slate-500 break-all"
                                    >
                                        charlie@ciilock.com
                                    </a>
                                    . If not within 24 hours, contact{" "}
                                    <a
                                        href="mailto:technology@ciilock.com"
                                        className="font-semibold text-slate-900 underline decoration-slate-300 underline-offset-4 hover:decoration-slate-500 break-all"
                                    >
                                        technology@ciilock.com
                                    </a>
                                    .
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tabs */}
                <div className="mt-6 flex justify-center">
                    <SegmentedTabs value={tab} onChange={setTab} />
                </div>

                {/* Content */}
                <div className="mt-5">
                    {tab === "domain" ? <DashboardDomainExternal /> : <DashboardContactExternal />}
                </div>
            </div>
        </div>
    );
}

function SegmentedTabs({ value, onChange }) {
    const tabs = [
        { id: "domain", label: "Domain" },
        { id: "contact", label: "Contact" },
    ];

    return (
        <div
            role="tablist"
            aria-label="Switch section"
            className="relative flex w-full max-w-md rounded-2xl border border-slate-200 bg-white p-1.5 shadow-sm"
        >
            {tabs.map((t) => {
                const active = value === t.id;

                return (
                    <button
                        key={t.id}
                        role="tab"
                        aria-selected={active}
                        aria-controls={`${t.id}-panel`}
                        className={[
                            "relative flex-1 h-11 rounded-xl px-4 font-semibold outline-none",
                            "transition-colors focus-visible:ring-2 focus-visible:ring-slate-400/70",
                            active ? "text-white" : "text-slate-700 hover:text-slate-900",
                        ].join(" ")}
                        onClick={() => onChange(t.id)}
                    >
                        {active && (
                            <motion.span
                                layoutId="seg-pill"
                                className="absolute inset-0 rounded-xl bg-slate-900 shadow-sm"
                                transition={{ type: "spring", stiffness: 500, damping: 35 }}
                            />
                        )}

                        <span className="relative z-10 flex items-center justify-center gap-2">
                            {/* Small dot indicator for visual hierarchy (UI-only) */}
                            <span
                                className={[
                                    "h-1.5 w-1.5 rounded-full",
                                    active ? "bg-white/90" : "bg-slate-300",
                                ].join(" ")}
                                aria-hidden="true"
                            />
                            {t.label}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
